import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Service } from "src/app/core/jsonapi/service";
import { Address } from "../_types/address";

@Injectable({
    providedIn: 'root',
})
export class AddressesService extends Service<Address> {
    public override type = 'addresses';
    public override url = 'common/addresses';

    //geoposiciona la dirección si no lo está ya y guarda latitud y longitud. El backend lanza error si Google no puede resolverla.
    public geocode(id: string): Observable<Address> {
        return this.http.post<Address>(this.getAPIUrl() + '/' + id + '/geocode', {});
    }
}
